export const storageKey = 'OTT/common/isBusinessTrip';

export const getBusinessTravelCheckboxValue = (): boolean =>
  typeof window !== 'undefined' ? window.sessionStorage.getItem(storageKey) === 'true' : false;
